import { createApp } from 'vue'
import Discount from './Discount.vue'
import './assets/global.css'

createApp(Discount).mount('#discount')
